import createIcon from '../../createIcon';

/**
 * @component @name HdrStrong
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgNkMxMy42OSA2IDExIDguNjkgMTEgMTJDMTEgMTUuMzEgMTMuNjkgMTggMTcgMThDMjAuMzEgMTggMjMgMTUuMzEgMjMgMTJDMjMgOC42OSAyMC4zMSA2IDE3IDZaTTUgOEMyLjc5IDggMSA5Ljc5IDEgMTJDMSAxNC4yMSAyLjc5IDE2IDUgMTZDNy4yMSAxNiA5IDE0LjIxIDkgMTJDOSA5Ljc5IDcuMjEgOCA1IDhaTTUgMTRDMy45IDE0IDMgMTMuMSAzIDEyQzMgMTAuOSAzLjkgMTAgNSAxMEM2LjEgMTAgNyAxMC45IDcgMTJDNyAxMy4xIDYuMSAxNCA1IDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HdrStrong = createIcon('HdrStrong', [
  [
    'path',
    {
      d: 'M17 6C13.69 6 11 8.69 11 12C11 15.31 13.69 18 17 18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM5 8C2.79 8 1 9.79 1 12C1 14.21 2.79 16 5 16C7.21 16 9 14.21 9 12C9 9.79 7.21 8 5 8ZM5 14C3.9 14 3 13.1 3 12C3 10.9 3.9 10 5 10C6.1 10 7 10.9 7 12C7 13.1 6.1 14 5 14Z',
      key: '19csmn',
    },
  ],
]);

export default HdrStrong;
